import { getCurrentInstance } from 'vue';
import { AppAbility } from '@/abilities.types';

export function useAbility(): AppAbility {
  const { proxy } = getCurrentInstance();
  return proxy.$ability;
}
